import { config } from "../AppConfig";

async function isUserLoggedIn() {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/auth`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "PATCH, OPTIONS",
      "Access-Control-Allow-Credentials": true,
    },
  });

  return {
    status: result.status,
    data: await result.json()
  }
}

async function logout() {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/auth/logout`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "PATCH, OPTIONS",
      "Access-Control-Allow-Credentials": true,
    },
  });
}

async function unbindDiscord() {
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/dashboard/unbind-discord`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      },
    }
  );
}

async function joinDiscordserver() {
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/dashboard/join-discord`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      },
    }
  );
  return result;
}

async function bindKeyToUser(key) {
  const payload = {
    key: key,
  };
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/dashboard/bind-licence`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      },
      body: JSON.stringify(payload),
    }
  );
  return {
    data: await result.json(),
    status: result.status,
  };
}

async function updatePassword(currentPassword, password, repeatPassword) {
  const payload = {
    currentPassword: currentPassword,
    newPassword: password,
    repeatNewPassword: repeatPassword,
  };
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/auth/update-password`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      },
      body: JSON.stringify(payload),
    }
  );
  return {
    data: await result.json(),
    status: result.status,
  };
}

async function register({
  token,
  email,
  fullName,
  password,
  confirmPassword,
}) {
  const payload = {
    email: email || null,
    fullName: fullName || null,
    password: password || null,
    confirmPassword: confirmPassword || null,
  };
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/auth/register`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      },
      body: JSON.stringify(payload),
    }
  );
  const json = await result.json();

  if (result.status === 201){
    return {
      data: json,
      error: null
    }
  } else if (result.status === 400) {
    return {
      data: null,
      error: { status: result.status, message: json.details[0].details }
    }
  } else if (result.status === 403) {
    return {
      data: null,
      error: { status: result.status, message: "Invalid Captcha"}
    }
  } else {
    return {
      data: null,
      error: { status: result.status, message: "Unknown Error During Registration"}
    }
  }
}

async function sendPasswordReset(email) {
  const payload = {
    email: email
  };
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/auth/forgot-password`,
    {
      method: "POST",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      },
      body: JSON.stringify(payload),
    }
  );
  return {
    data: await result.json(),
    status: result.status,
  };
}

async function unbindHwid() {
  const result = await fetch(
    `${config.url.API_BASE}/api/ajax/v1/dashboard/unbind-hwid`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Methods": "PATCH, OPTIONS",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Request-Credentials": "include",
      }
    }
  );
  return {
    status: result.status,
  };
}

export const userService = {
  isUserLoggedIn,
  unbindDiscord,
  logout,
  joinDiscordserver,
  updatePassword,
  bindKeyToUser,
  register,
  sendPasswordReset,
  unbindHwid
};
